import { Label, Input, fieldClassName, labelClassName, errorTextClassName } from '@shared/ui';
import { useAuthStore } from '@features/auth/store/authStore';
import { getSiteName } from '@shared/utils/firmName';
import { sectionHeading } from '../profileStyles';

export function OrganizationSection({
  firmName,
  canEditCompany,
  register,
  errors,
  dataTestId
}) {
  const baseTestId = dataTestId || 'profile-organization-section';
  // Multi-site: the customer (firm) name above is shared across every site; the active site is
  // shown as a read-only sub-line so a user acting on a secondary site understands this profile
  // belongs to the customer as a whole, not just the site they're currently in. Only rendered
  // when the customer actually has more than one site — a single-site customer would see noise.
  const selectedSite = useAuthStore((s) => s.selectedSite);
  const selectedCompanySites = useAuthStore((s) => s.selectedCompany?.sites);
  const hasMultipleSites = Array.isArray(selectedCompanySites) && selectedCompanySites.length > 1;
  const activeSiteName = hasMultipleSites ? getSiteName(selectedSite) : '';
  return (
    <div className="space-y-4" data-testid={baseTestId}>
      <h3 className={sectionHeading} data-testid={`${baseTestId}-header`}>Organization Profile</h3>
      <div className="space-y-2">
        <Label htmlFor="firmName" className={labelClassName} data-testid={`${baseTestId}-label`}>
          Customer / Company Name
        </Label>
        <Input
          id="firmName"
          {...register('firmName')}
          className={`${fieldClassName} w-full ${canEditCompany ? 'text-fg' : 'text-fg-disabled'}`}
          aria-invalid={!!errors.firmName}
          readOnly={!canEditCompany}
          data-testid={`${baseTestId}-input`}
        />
        {errors.firmName && (
          <p className={`${errorTextClassName} mt-1`} data-testid={`${baseTestId}-error`}>{errors.firmName.message}</p>
        )}
        <p className="text-xs text-fg-muted mt-1" data-testid={`${baseTestId}-info`}>
          This name appears on invoices, quotes, and billing details.        </p>
      </div>
      {activeSiteName && (
        <div className="space-y-1" data-testid={`${baseTestId}-active-site`}>
          <Label className={labelClassName} data-testid={`${baseTestId}-active-site-label`}>
            Active Site
          </Label>
          <p className="text-sm text-fg" data-testid={`${baseTestId}-active-site-value`}>{activeSiteName}</p>
          <p className="text-xs text-fg-muted" data-testid={`${baseTestId}-active-site-info`}>
            The site your subscriptions, invoices, and users are scoped to. Switch sites from the sidebar.
          </p>
        </div>
      )}
    </div>
  );
}
